import { Link } from "react-router-dom";
import React from "react";

export default function Subheader({ subheadData }) {
  return (
    <div className="subheader">
      <div className="subheader-text">
        {subheadData.title && <span>{subheadData.title}</span>}
        <p className="subheader-head">{subheadData.heading}</p>
        {subheadData.pagename && (
          <ul>
            <li>
              <Link to={"/"}>Home</Link>
            </li>
            <li> | </li>
            <li> {subheadData.pagename} </li>
          </ul>
        )}
      </div>

      <img src={subheadData.image} className="img-responsive" alt="banner" />
    </div>
  );
}
